import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as service from '@/services/notifications.service';

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (limit: number) => [...notificationKeys.all, 'list', limit] as const,
  unread: () => [...notificationKeys.all, 'unread'] as const,
};

export function useMyNotifications(limit = 30) {
  return useQuery({
    queryKey: notificationKeys.list(limit),
    queryFn: () => service.getMyNotifications(limit),
    // The bell should catch a mention landing while the tab is open, without
    // being chatty about it.
    refetchInterval: 60_000,
  });
}

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: notificationKeys.unread(),
    queryFn: service.unreadCount,
    refetchInterval: 60_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: service.markRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: service.markAllRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}
